import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import CategorySelection from './CategorySelection';
import ItemRanking from './ItemRanking';
import { ONBOARDING_ROUTES } from './onboardingUtils';

export function Onboarding() {
  const location = useLocation();
  
  return (
    <Routes>
      <Route path="" element={<CategorySelection />} />
      <Route path="/rank-items" element={<ItemRanking />} />
    </Routes>
  );
}

export default Onboarding;
